import { createSlice } from '@reduxjs/toolkit';

const systemRulesFilterSlice = createSlice({
    name: 'systemRulesFilter',
    initialState: {
        isLoadingRules: true,
        isLoadingDevices: true,
        isLoadingUsers: true,
        isLoadingUserGroups: true,
        isError: false,
        error: false,
        getAllRulesType: [],
        getAllDevices: [],
        getAllUsers: [],
        getAllUserGroups: [],
    },
    reducers: {
        fetchAllSystemRulesOption: (state, action) => {
            state.getAllRulesType = action.payload;
            state.isLoadingRules = false;
        },
        fetchAllSystemRulesOptionError: (state, action) => {
            state.isLoadingRules = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
        fetchAllDevices: (state, action) => {
            state.getAllDevices = action.payload;
            state.isLoadingDevices = false;
        },
        fetchAllDevicesError: (state, action) => {
            state.isLoadingDevices = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
        fetchAllUsers: (state, action) => {
            state.getAllUsers = action.payload;
            state.isLoadingUsers = false;
        },
        fetchAllUsersError: (state, action) => {
            state.isLoadingUsers = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
        fetchAllUserGroups: (state, action) => {
            state.getAllUserGroups = action.payload;
            state.isLoadingUserGroups = false;
        },
        fetchAllUserGroupsError: (state, action) => {
            state.isLoadingUserGroups = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
    },
});

export const {
    fetchAllSystemRulesOption,
    fetchAllSystemRulesOptionError,
    fetchAllDevices,
    fetchAllDevicesError,
    fetchAllUsers,
    fetchAllUsersError,
    fetchAllUserGroups,
    fetchAllUserGroupsError,
} = systemRulesFilterSlice.actions;

export default systemRulesFilterSlice.reducer;
